import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Basket: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.03433 20.3099L1.42692 12.3099C1.21628 11.6636 1.69795 11 2.3777 11H21.6223C22.302 11 22.7837 11.6636 22.5731 12.3099L19.9657 20.3099C19.8315 20.7215 19.4478 21 19.0149 21H4.98511C4.55222 21 4.16848 20.7215 4.03433 20.3099Z"
        stroke={color}
        strokeWidth="2"
      />
      <line
        x1="1"
        y1="-1"
        x2="10.0442"
        y2="-1"
        transform="matrix(0.452726 -0.89165 0.83595 0.548805 4.5 12)"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="5.69904"
        y1="11.9022"
        x2="7.74988"
        y2="20.8008"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="1"
        y1="-1"
        x2="10.1319"
        y2="-1"
        transform="matrix(-0.22458 0.974456 0.974456 0.22458 19.5 11)"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="1"
        y1="-1"
        x2="10.0442"
        y2="-1"
        transform="matrix(0.452726 0.89165 -0.83595 0.548805 14.5 2)"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line x1="12" y1="12" x2="12" y2="20" stroke={color} strokeWidth="2" />
      <rect x="3" y="15" width="19" height="2" fill={color} />
    </svg>
  );
};

export default Basket;
